import {connect} from 'react-redux';
import GoogleStreetViewImagePopup from './GoogleStreetViewImagePopup';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';

export default connect(
  null,
  {showGlobalErrorMessage}
)(GoogleStreetViewImagePopup);
